'use client'

import { Box, Text, CheckboxGroup as ChakraCheckboxGroup } from '@chakra-ui/react'

/**
 * Varios Checkbox.Root dentro del mismo Field.Root de Chakra/Ark comparten el
 * mismo id del input oculto y se comportan como radios. Para multi-select:
 * no uses Field.Root; usa MultiCheckboxField (o un Box + label).
 *
 * IsolateCheckboxesFromField se mantiene como passthrough por compatibilidad
 * con llamadas existentes (el arreglo real es no envolver en Field.Root).
 */
export function IsolateCheckboxesFromField({ children }) {
  return children
}

/** Sustituto de Field.Root cuando el control es un grupo de checkboxes. */
export function MultiCheckboxField({ label, children, labelProps, ...boxProps }) {
  return (
    <Box w="full" textAlign="left" {...boxProps}>
      {label != null && label !== false ? (
        typeof label === 'string' || typeof label === 'number' ? (
          <Text as="div" fontSize="sm" fontWeight="medium" mb={1} textAlign="left" {...labelProps}>
            {label}
          </Text>
        ) : (
          label
        )
      ) : null}
      {children}
    </Box>
  )
}

export function CheckboxGroup(props) {
  return <ChakraCheckboxGroup {...props} />
}
